/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/components/form';
import {
  Separator,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Switch,
} from '@e2n/ui';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Anstellungstyp } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/anstellungstyp';
import { useTranslation } from 'react-i18next';

export function Anstellung() {
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <h2 className="text-neutrals-900 text-xl font-bold leading-7">
          {ctx.getCurrentSubStep()?.title}
        </h2>
        <p className="text-neutrals-800 text-sm font-normal leading-5">
          {t(
            'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.description',
          )}
        </p>
      </div>

      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
        <form.AppField name="anstellungsverhaeltnis.anstellung.anstellungstyp">
          {(field) => (
            <FieldBase
              isRequired
              label={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.label',
              )}>
              <Select
                onValueChange={field.handleChange}
                value={field.state.value}>
                <SelectTrigger id={field.name} onBlur={field.handleBlur}>
                  <SelectValue
                    placeholder={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.placeholder',
                    )}
                  />
                </SelectTrigger>
                <SelectContent className="max-h-44 overflow-y-scroll">
                  {Object.keys(Anstellungstyp).map((anstellungstyp) => (
                    <SelectItem
                      key={anstellungstyp}
                      value={anstellungstyp}
                      className="p-2">
                      {t(
                        `domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.options.${anstellungstyp}`,
                      )}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FieldBase>
          )}
        </form.AppField>
        <form.AppField name="anstellungsverhaeltnis.anstellung.eintrittsdatum">
          {(field) => (
            <field.DatePicker
              isRequired
              infoText={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.eintrittsdatum.info',
              )}
              placeholder={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.eintrittsdatum.placeholder',
              )}
              label={t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.eintrittsdatum.label',
              )}
            />
          )}
        </form.AppField>
      </div>
      <Separator />
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
        <div className="flex flex-col gap-4 col-span-2">
          <h3 className="text-neutrals-900 text-base font-bold leading-6">
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristung.label',
            )}
          </h3>

          <form.Field name="anstellungsverhaeltnis.anstellung.befristet">
            {(field) => (
              <div className="flex items-center space-x-2">
                <Switch
                  id="befristungToggle"
                  size="sm"
                  checked={field.state.value}
                  onCheckedChange={field.handleChange}
                />
                <Label
                  htmlFor="befristungToggle"
                  className="text-neutrals-900 text-sm font-normal leading-5">
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristung.description',
                  )}
                </Label>
              </div>
            )}
          </form.Field>
        </div>
        <form.Subscribe
          selector={(state) =>
            state.values.anstellungsverhaeltnis.anstellung.befristet
          }>
          {(befristet) =>
            befristet && (
              <form.AppField name="anstellungsverhaeltnis.anstellung.befristung">
                {(field) => (
                  <field.DatePicker
                    isRequired
                    placeholder={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristetBis.placeholder',
                    )}
                    label={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristetBis.label',
                    )}
                  />
                )}
              </form.AppField>
            )
          }
        </form.Subscribe>
      </div>
    </div>
  );
}
